const NO_RETURN_PATHS = ['/login', '/login-with-provider', '/signup', '/confirm', '/reset-password', '/confirm-reset-password', '/oauth-login', '/404']

const isNoReturnPath = (path) => {
  const lowerPath = path.toLowerCase()
  return NO_RETURN_PATHS.some((noReturnPath) => lowerPath === noReturnPath || lowerPath.startsWith(`${noReturnPath}/`))
}

export function safeRedirectPath (redirect) {
  if (typeof redirect !== 'string' || !redirect.startsWith('/')) {
    return null
  }
  try {
    // parse instead of prefix checks: browsers read "/\evil.com" as "//evil.com"
    const url = new URL(redirect, window.location.origin)
    if (url.origin !== window.location.origin || isNoReturnPath(url.pathname)) {
      return null
    }
    return url.pathname + url.search + url.hash
  } catch {
    return null
  }
}

export function loginRoute (returnPath, query = {}) {
  return { path: '/login', query: { ...query, redirect: safeRedirectPath(returnPath) || undefined } }
}
